import { MihatoMark } from "@/common/components/MihatoMark";
import { LandingIcon } from "./LandingIcon";

export function LandingNav() {
  return (
    <nav className="relative z-20 flex items-center justify-between border-white/[0.06] border-b px-6 py-5 md:px-12">
      <div className="flex w-1/3 items-center gap-3">
        <MihatoMark className="h-7 w-7 text-white" />
        <span className="font-medium text-lg tracking-tight">HATO</span>
      </div>

      <div className="hidden flex-1 justify-center md:flex">
        <div className="flex items-center gap-8 rounded-full border border-white/[0.06] bg-white/[0.01] px-8 py-2 text-neutral-400 text-sm backdrop-blur-md">
          <a href="#features" className="transition-colors hover:text-white">
            Funcionalidades
          </a>
          <a href="#method" className="transition-colors hover:text-white">
            Método
          </a>
          <a href="#customers" className="transition-colors hover:text-white">
            Clientes
          </a>
        </div>
      </div>

      <div className="flex w-1/3 items-center justify-end gap-6">
        <a
          href="/login"
          className="hidden items-center gap-2 text-neutral-400 text-sm transition-colors hover:text-white lg:flex"
        >
          <LandingIcon name="lock-password" size={16} />
          Ingresar
        </a>
        <a
          href="/access-request"
          className="rounded-full border border-white/[0.1] px-5 py-2 text-sm transition-colors hover:bg-white/[0.05]"
        >
          Solicitar acceso
        </a>
      </div>
    </nav>
  );
}
